var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2971 36.0201H6.46519C5.25727 35.9196 4.13126 35.3687 3.3105 34.4767C2.48974 33.5848 2.03418 32.417 2.03418 31.2049C2.03418 29.9928 2.48974 28.8249 3.3105 27.933C4.13126 27.041 5.25727 26.4902 6.46519 26.3896H14.1296L19.0616 21.4577L5.53213 13.1268C4.49056 12.4829 3.7323 11.4676 3.41063 10.286C3.08896 9.10452 3.22788 7.84495 3.7993 6.76193C4.05154 6.14212 4.42811 5.58056 4.90576 5.1119C5.38341 4.64324 5.95201 4.27741 6.5765 4.03698C7.20099 3.79655 7.86812 3.68662 8.53673 3.71397C9.20535 3.74132 9.86127 3.90537 10.464 4.196L28.1256 12.3603L36.6565 3.72947C37.5756 2.81032 38.8223 2.29395 40.1221 2.29395C41.422 2.29395 42.6686 2.81032 43.5878 3.72947C44.5069 4.64862 45.0233 5.89526 45.0233 7.19514C45.0233 8.49501 44.5069 9.74165 43.5878 10.6608L34.957 19.1917L43.1213 37.0198C43.3898 37.6135 43.5364 38.2551 43.5523 38.9066C43.5682 39.558 43.453 40.206 43.2137 40.812C42.9744 41.4181 42.6158 41.9699 42.1591 42.4348C41.7025 42.8996 41.1571 43.2679 40.5553 43.518C39.4723 44.0894 38.2127 44.2283 37.0312 43.9066C35.8497 43.585 34.8344 42.8267 34.1905 41.7851L25.8596 28.2557L20.9277 33.1876V40.8521C20.8271 42.06 20.2762 43.186 19.3843 44.0068C18.4923 44.8275 17.3245 45.2831 16.1124 45.2831C14.9003 45.2831 13.7325 44.8275 12.8405 44.0068C11.9486 43.186 11.3977 42.06 11.2971 40.8521V36.0201Z",
    stroke: "#1D1DE3",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.6532,
    height: 46.6532,
    fill: "white",
    transform: "translate(0 0.662109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneBlue);
export default __webpack_public_path__ + "static/media/plane-blue.9ecb1013af6337bf73108279bfcfbe93.svg";
export { ForwardRef as ReactComponent };